import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

/**
 * Warning dialog shown when emitting a Final invoice that has trips with
 * Adelanto = 0 even though the client already appears in a previous Advance
 * invoice (the user probably forgot to load the Adelanto value).
 */
export default function MissingAdelantoDialog({ open, onOpenChange, warnings, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="missing-adelanto-dialog" className="max-w-xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="text-amber-500" size={20} />
            Posibles adelantos no descontados
          </AlertDialogTitle>
          <AlertDialogDescription>
            Los siguientes clientes tienen <strong>Adelanto = 0</strong> en esta factura final,
            pero ya aparecen en una factura de <strong>adelanto</strong> emitida anteriormente.
            Comprueba si te falta introducir el importe del adelanto.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="max-h-72 overflow-y-auto -mx-2 px-2">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 sticky top-0">
              <tr>
                <th className="text-left py-2 px-3 text-[10px] uppercase tracking-wider text-slate-600 font-semibold">Cliente</th>
                <th className="text-left py-2 px-3 text-[10px] uppercase tracking-wider text-slate-600 font-semibold">Adelanto cobrado en</th>
              </tr>
            </thead>
            <tbody>
              {warnings.map((w, i) => (
                <tr key={`${w.name}-${i}`} className="border-t border-slate-100" data-testid={`missing-adelanto-row-${i}`}>
                  <td className="py-2 px-3 text-slate-900">{w.name}</td>
                  <td className="py-2 px-3 text-slate-600 font-mono">{w.advanceInvoices.join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="missing-adelanto-cancel-btn">Revisar adelantos</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-slate-900 hover:bg-slate-800" data-testid="missing-adelanto-confirm-btn">
            Emitir igualmente
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
